import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthRedirectUriResolver } from './modules/auth/auth-redirect-uri.resolver';

const routes: Routes = [
  { 
    path: '' ,
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'support',
      },
      {
        path: 'patient-consent',
        loadChildren: () =>
          import('./modules/patient-consent/patient-consent.module').then(
            (m) => m.PatientConsentModule
          ),
        data: {
          title: 'patient-consent.title',
        },
      },
      {
        path: 'institution',
        loadChildren: () =>
          import(
            './modules/institution/institution.module'
          ).then((m) => m.InstitutionModule),
        data: {
          title: 'affiliate-institution.title',
        },
      },
      {
        path: 'institution-staff-mutation',
        redirectTo: 'institution/staff-mutation',
        data: {
          title: 'staff-transfer-request.title',
        },
      },
      {
        path: 'community-change',
        loadChildren: () =>
          import(
            './modules/community-change/community-change.module'
          ).then((m) => m.CommunityChangeModule),
        data: {
          title: 'community-change.title',
        },
      },
      {
        path: 'support',
        loadChildren: () =>
          import('./modules/support/support.module').then((m) => m.SupportModule),
        data: {
          title: 'support.title',
        },
      },
      {
        path: 'elearning',
        loadChildren: () =>
          import('./modules/elearning/elearning.module').then((m) => m.ElearningModule),
        data: {
          title: 'elearning.title',
        },
      },
    ],
    resolve: [
      AuthRedirectUriResolver
    ],
    runGuardsAndResolvers: 'always'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
